<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="!!data">
    <InputRadio
        ref="input"
        v-model="data"
        :options="relationshipHaveOptions"
        :db="db"
        :args="args"
        :skipped="skipped"
        @saveComplete="$emit('calculateRelationshipStatus')"
        @skipped="skipped=$event"
        class="radio-options-wide"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "../../../helpers/questionLoadHelpers";
import { personalDetails } from "../../../options/personalDetails";

import QuestionBase from "../../../QuestionBase";
import InputRadio from "../../../inputs/InputRadio";

export default {
  name: 'RelationshipStatus',
  mixins: [personalDetails, questionLoadHelpers],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: String,
      required: false
    },
    statusFunction: {
      type: Function,
      required: true
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title:  'What is your current relationship status?',
        subTitle:  'Choose the option that best represents your current situation. If you were previously divorced or widowed but are now in a relationship please select married, partnered or engaged.',
        tip: null,
      },
      db: {
        saveLocation: 'client_client',
        saveField: 'profileRelationshipCurrentStatus',
        callbackFunction: this.statusFunction
      },
      args: {
        skippable: false,
        label: null,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
